export default __webpack_public_path__ + "static/media/PowerShard.256.3b77ccd8.png";